import { render, staticRenderFns } from "./LabResult.vue?vue&type=template&id=16c2031a&scoped=true&"
import script from "./LabResult.vue?vue&type=script&lang=ts&"
export * from "./LabResult.vue?vue&type=script&lang=ts&"
import style0 from "@/logs.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./LabResult.vue?vue&type=style&index=1&id=16c2031a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c2031a",
  null
  
)

export default component.exports